import { t } from 'i18next';
import { useEffect, useState } from 'react';

import editIcon from '../../assets/img/icons/edit.svg';
import itemIcon from '../../assets/img/icons/item.svg';
import PlusIcon from '../../assets/img/icons/plus_white.svg';
import TickWhite from '../../assets/img/icons/tick_2.svg';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import { PrimaryButton, SecondaryButton } from '../../styledComponents/buttons';
import {
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
  Container,
  InputField,
  PageTitle,
} from '../../styledComponents/common';
import { CheckBoxSquare } from '../../styledComponents/tasks';
import { InfoSection } from '../Offices/officesStyles';
import AddItemModal from './AddItemModal';

const Items = ({
  itemsList,
  isLoading,
  getItemsList,
  addItem,
  editItem,
  deleteItem,
  isCrudLoading,
}) => {
  const [imagePreview, setImagePreview] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalCanStayOpen, setModalCanStayOpen] = useState(false);
  const addFile = file => {
    setImagePreview(URL.createObjectURL(file[0]));
  };

  const [pdfPreview, setPdfPreview] = useState(null);
  const [editItemIndex, setEditItemIndex] = useState(null);

  useEffect(() => {
    getItemsList();
  }, []);

  useEffect(() => {
    if (isCrudLoading) {
      setModalCanStayOpen(true);
    } else if (modalCanStayOpen && !isCrudLoading && isModalOpen) {
      setModalCanStayOpen(false);
      toggleModal();
    }
  }, [isCrudLoading]);

  const toggleModal = () => {
    if (isModalOpen && editItemIndex !== null) {
      setEditItemIndex(null);
    }
    setIsModalOpen(!isModalOpen);
  };

  const handleAddItem = ({ itemName, same_as_pilgrims, priority }) => {
    addItem({ name: itemName, same_as_pilgrims, priority });
  };

  const handleEditItem = ({ itemName, same_as_pilgrims, priority }) => {
    editItem({
      id: itemsList[editItemIndex].id,
      name: itemName,
      same_as_pilgrims,
      priority,
    });
  };

  const handleDeleteItem = id => {
    deleteItem({ id });
  };

  return (
    <div className="content">
      <PageTitle>{t('items')}</PageTitle>
      <Container>
        <AddItemModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          handleAddItem={handleAddItem}
          handleEditItem={handleEditItem}
          item={itemsList[editItemIndex]}
          isLoading={isCrudLoading}
        />
        <InfoSection
          style={{
            padding: '30px',
          }}
        >
          <CommonFlex justifyContent="space-between">
            <CommonText name title fontSize="16px">
              {t('all_items')}
            </CommonText>
            <CommonFlex gap="5px" onClick={toggleModal}>
              <PrimaryButton
                style={{
                  gap: '5px',
                }}
              >
                <img src={PlusIcon} alt="tick" width="16px" height="16px" />
                {t('add_item')}
              </PrimaryButton>
            </CommonFlex>
          </CommonFlex>
          {isLoading ? (
            <ComponentCircleLoader />
          ) : (
            <CommonFlex
              gap="10px"
              direction="column"
              alignItems="start"
              style={{
                marginTop: '10px',
              }}
            >
              {itemsList?.map((item, index) => (
                <CommonGrid
                  key={item.id}
                  columns="1fr 1fr"
                  style={{
                    width: '600px',
                  }}
                >
                  <CommonFlex gap="5px">
                    <img src={itemIcon} alt="tick" width="18px" height="18px" />
                    <CommonText name>{item.name}</CommonText>
                  </CommonFlex>
                  <CommonFlex gap="15px" width="max-content">
                    <CommonFlex
                      gap="5px"
                      style={{
                        height: '40px',
                      }}
                    >
                      <CheckBoxSquare
                        checked={item.same_as_pilgrims}
                        noHover={true}
                        cursor="default"
                      >
                        <img
                          src={TickWhite}
                          alt="tick"
                          width="16px"
                          height="16px"
                        />
                      </CheckBoxSquare>
                      <CommonText margin="0" name>
                        {t('same_number_of_pilgrims')}
                      </CommonText>
                    </CommonFlex>
                    {/*  <CommonImage
                      src={editIcon}
                      alt="edit"
                      style={{ zIndex: '2', cursor: 'pointer' }}
                      onClick={() => {
                        setEditItemIndex(index);
                        toggleModal();
                      }}
                    /> */}
                    {/* <PrimaryButton onClick={() => handleDeleteItem(item.id)}>
                      {t('delete')}
                    </PrimaryButton> */}
                  </CommonFlex>
                </CommonGrid>
              ))}
            </CommonFlex>
          )}
        </InfoSection>
      </Container>
    </div>
  );
};

export default Items;
